import { useEffect } from 'react';
import { InlineWidget } from 'react-calendly';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/lib/translations';

const ContactSales = () => {
  const { language } = useLanguage();
  const defaultLanguage = 'en';
  const t = translations[language]?.contactSales || translations[defaultLanguage].contactSales;

  useEffect(() => {
    // Load Calendly styles
    const head = document.querySelector('head');
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = 'https://assets.calendly.com/assets/external/widget.css';
    head?.appendChild(style);

    return () => {
      // Cleanup styles on unmount
      const existingStyle = document.querySelector('link[href="https://assets.calendly.com/assets/external/widget.css"]');
      existingStyle?.remove();
    };
  }, []);

  if (!t) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-4">{t.title}</h1>
          <p className="text-xl text-gray-600 mb-6">
            {t.subtitle}
          </p>
        </div>
        
        <div className="calendly-container h-[700px] rounded-lg shadow-lg overflow-hidden">
          <InlineWidget
            url="https://calendly.com/automata-artificialintelligence/30min"
            styles={{
              height: '100%',
              width: '100%',
            }}
          />
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-4">
            <h3 className="font-semibold mb-2">{t.sections.needs.title}</h3>
            <p className="text-gray-600">{t.sections.needs.description}</p>
          </div>
          <div className="text-center p-4">
            <h3 className="font-semibold mb-2">{t.sections.solutions.title}</h3>
            <p className="text-gray-600">{t.sections.solutions.description}</p>
          </div>
          <div className="text-center p-4">
            <h3 className="font-semibold mb-2">{t.sections.pricing.title}</h3>
            <p className="text-gray-600">{t.sections.pricing.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSales; 